import { Gamepad2, MessageCircle, MessagesSquare, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { LINKS } from "@/data/content";
import { Reveal, SectionHead } from "./Reveal";
import { CopyIp } from "./CopyIp";
import { useDiscordStatus } from "@/hooks/useDiscordStatus";

const ICONS = { mta: Gamepad2, discord: MessageCircle, forum: MessagesSquare };

const LinkCard = ({ item, index }) => {
  const Icon = ICONS[item.id];
  const discord = useDiscordStatus();
  const meta =
    item.id === "discord" && discord?.ok ? `${discord.online} online · ${discord.members} tag` : item.meta;
  const Tag = item.route ? Link : "a";
  const linkProps = item.route ? { to: item.href } : { href: item.href, target: item.external ? "_blank" : undefined, rel: item.external ? "noreferrer" : undefined };
  return (
    <Reveal delay={index * 0.1} y={48}>
      <Tag
        {...linkProps}
        data-testid={`link-card-${item.id}`}
        className="card-glow group relative flex h-full flex-col justify-between overflow-hidden rounded-3xl border border-white/[0.08] bg-[#111113] p-8 sm:p-10"
      >
        <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[radial-gradient(circle,rgba(94,177,255,0.25),transparent_65%)] opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100" />
        <div className="flex items-start justify-between">
          <span className="grid h-12 w-12 place-items-center rounded-2xl border border-white/10 bg-white/[0.04] text-white transition-colors duration-300 group-hover:border-[rgba(94,177,255,0.5)] group-hover:text-[var(--glow)]">
            <Icon size={20} />
          </span>
          <span className="grid h-10 w-10 place-items-center rounded-full border border-white/10 text-white/50 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:border-white/30 group-hover:text-white">
            <ArrowUpRight size={16} />
          </span>
        </div>
        <div className="mt-16">
          <h3 className="font-display text-xl font-bold leading-tight text-white sm:text-2xl">{item.label}</h3>
          <p className="mt-3 font-mono text-xs tracking-wider text-white/40" data-testid={`link-card-${item.id}-meta`}>{meta}</p>
        </div>
      </Tag>
    </Reveal>
  );
};

export const Links = () => (
  <section id="csatlakozas" className="relative py-28 sm:py-36" data-testid="links-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHead eyebrow={LINKS.eyebrow} title="Csatlakozás" testId="links-head" />
        <Reveal delay={0.2}>
          <CopyIp testId="links-copy-ip" />
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
        {LINKS.items.map((item, i) => <LinkCard key={item.id} item={item} index={i} />)}
      </div>
    </div>
  </section>
);
